import { render } from "./PersonaContactoForm.vue?vue&type=template&id=48ec671a&scoped=true"
import script from "./PersonaContactoForm.vue?vue&type=script&lang=js"
export * from "./PersonaContactoForm.vue?vue&type=script&lang=js"

import "./PersonaContactoForm.vue?vue&type=style&index=0&id=48ec671a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ec671a"]])

export default __exports__